const primaryFontFamily = 'Anton'
const secondaryFontFamily = 'Roboto'

const primaryColor = 'rgb(13, 40, 20)' // Deep green
const secondaryColor = 'rgb(24, 23, 26)' // Dark gray-black
const backgroundColor = '#f8f9e8' // Light beige
const borderColor = '#3e5344' // Olive gray

export const mainColors = {
  primaryColor,
  secondaryColor: '#def2a0',
  backgroundColor,
  borderColor
}

const theme = {
  headline: {
    fontFamily: primaryFontFamily,
    color: primaryColor,
  },
  text: {
    fontFamily: secondaryFontFamily,
    color: secondaryColor,
  },
  spacer: {
    color: 'rgba(0, 0, 0, 0)', // Transparent
  },
  button: {
    fontFamily: secondaryFontFamily,
    color: backgroundColor, // Light beige
    borderColor: primaryColor, // Deep green
    backgroundColor: primaryColor, // Deep green
  },
  rank: {
    baseColor: 'rgba(251, 180, 2, 1)', // Gold
  },
  image: {
    backgroundColor: 'rgba(0, 0, 0, 0)', // Transparent
  },
  field: {
    fontFamily: secondaryFontFamily,
    color: primaryColor, // Deep green
    borderColor: '#000000', // Black
    backgroundColor: backgroundColor, // Light beige
  },
  social: {
    color: '#0e2814', // Dark green
  },
  survey: {
    color: backgroundColor, // Light beige
    borderColor: '#0e2814', // Dark green
    backgroundColor: '#0e2814', // Dark green
  },
  wheel: {
    fontFamily: primaryFontFamily,
    color: backgroundColor, // Light beige
    borderColor: 'rgb(0, 0, 0)', // Black
    backgroundColor: '#0e2814', // Dark green
    secondaryBackgroundColor: borderColor, // Olive gray
  },
  voucher: {
    fontFamily: secondaryFontFamily,
    color: secondaryColor, // Dark gray-black
  },
  checkbox: {
    color: backgroundColor, // Light beige
    borderColor: borderColor, // Olive gray
    checkboxColor: backgroundColor, // Light beige
    backgroundColor: '#0e2814', // Dark green
  },
}

export default {
  theme,
  mainColors,
}
